<template>
  <div class="MobileFooter">
    <div class="nav_box_content">
      <div class="nav_box">
        <div>{{$t('PublicComponents.Footer.Nav')}}</div>
         <ul>
            <li class="li" @click="toPath('/datahub')">{{$t('PublicComponents.Footer.DataHub')}}</li>
            <li  class="li" @click="toPath('/newslist?type=Society')">{{$t('PublicComponents.Footer.Society')}}</li>
            <li  class="li" @click="toPath('/newslist?type=Technology')">{{$t('PublicComponents.Footer.Science')}}</li>
            <li  class="li" @click="toPath('/newslist?type=Case')">{{$t('PublicComponents.Footer.Practices')}}</li>
            <li  class="li" @click="tip('/sdgsindicators')">{{$t('PublicComponents.Footer.Knowledge')}}</li>
        </ul>
      </div>
      <div class="nav_box">
        <div>{{$t('PublicComponents.Footer.Link')}}</div>
        <ul>
          <li> <a href="http://www.casearth.com" target="_blank">{{$t('PublicComponents.Footer.Link1')}}</a></li>
          <li> <a href="http://www.cbas.ac.cn/"  target="_blank">{{$t('PublicComponents.Footer.Link3')}}</a></li>
          <li><a
              href="https://www.un.org/sustainabledevelopment/zh/"
              target="_bank"
            >{{$t('PublicComponents.Footer.Link4')}}</a></li>
        </ul>
      </div>
    </div>
    <div class="img_box">
      <img class="footer_img1" src="@/assets/image/Logo/home_side_bar.png" alt />
      <img class="footer_img3" src="@/assets/image/Logo/home_side_bar_sdg.png" alt />
    </div>
    <div class="content_us">
      <div class="title">{{$t('PublicComponents.Footer.ContactUs')}}</div>
      <div class="content_us_txt_box">
        <div class="content_us_txt_box_img">
          <img src="@/assets/image/Public/QR1.jpg" alt />
          <!-- <div>可持续发展大数据国际研究中心官方微信公众号</div> -->
        </div>
        <div class="content_us_txt_box_info">
         
          <div  class="flex_content"><div class="name">{{$t('PublicComponents.Footer.Email')}}:</div><div>secretariat@cbas.ac.cn</div></div>
          <div  class="flex_content"><div class="name">{{$t('PublicComponents.Footer.Address')}}:</div><div>{{$t('PublicComponents.Footer.AddressInfo')}}</div></div>
        </div>
      </div>
    </div>
    <div class="copyright">{{$t('PublicComponents.Footer.Copyright')}}</div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui';
export default {
  methods: {
     tip() {
      Toast({
        message: this.$t("Nav.Menu.UnderDevelopment"),
        position: "center",
        duration: 2000
      });
    },
      toPath(path){
      this.$router.push(path)
    }
  },
};
</script>

<style lang="scss" scoped>
.MobileFooter {
  width: 100%;
  background: #3d3f4d;
  display: flex;
  flex-direction: column;
}
@media screen and (min-width: 768px) and (max-width: 1040px) {
  .MobileFooter {
    .nav_box_content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      color: #fff;
      .nav_box {
        padding: 0 20px;
        width: 100%;
        font-size: 20px;
        height: 88px;
        line-height: 88px;
        border-bottom: 1px solid rgba(85, 88, 109, 1);
      }
    }
    .img_box {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 20px;
      .footer_img1 {
        width: 147px;
        height: 78px;
        margin-right: 32px;
      }
      .footer_img3 {
        width: 72px;
        height: 72px;
      }
    }
    .content_us {
      padding: 0 20px 20px 20px;
      border-bottom: 1px solid rgba(85, 88, 109, 1);
      .title {
        margin-bottom: 20px;
        font-size: 18px;
        color: #fff;
      }
      .content_us_txt_box {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        .content_us_txt_box_img {
          display: flex;
          flex-direction: column;
          img {
            width: 100px;
            height: 100px;
            margin-right: 20px;
          }
        }
        .content_us_txt_box_info {
          color: #fff;
          font-size: 16px;
        }
      }
    }
    .copyright {
      text-align: center;
      padding: 20px;
      color: rgba(255, 255, 255, 0.5);
      font-size: 16px;
    }
  }
}
@media screen and (max-width: 767px) {
  .MobileFooter {
    .nav_box_content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      color: #fff;
      .nav_box {
        padding: 10px 20px;
        width: 100%;
        font-size: 18px;
        // height: 88px;
        line-height: 40px;
        border-bottom: 1px solid rgba(85, 88, 109, 1);
        ul{
          // margin-left: 20px;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          padding-top: 8px;
          li{
            color: #ccc;
            margin-right: 20px;
            // height: 40px;
            margin-bottom: 16px;
            line-height: 20px;
            font-size: 14px;
            a{
               color: #ccc;
            }
          }
        }
      }
    }
    .img_box {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 20px;
      .footer_img1 {
        width: 147px;
        height: 78px;
        margin-right: 32px;
      }
      .footer_img3 {
        width: 72px;
        height: 72px;
      }
    }
    .content_us {
      padding: 0 20px 20px 20px;
      border-bottom: 1px solid rgba(85, 88, 109, 1);
      .title {
        margin-bottom: 20px;
        font-size: 18px;
        color: #fff;
      }
      .content_us_txt_box {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        .content_us_txt_box_img {
          display: flex;
          flex-direction: column;
          img {
            width: 100px;
            height: 100px;
            margin-bottom: 20px;
          }
        }
        .content_us_txt_box_info {
          color: #fff;
          font-size: 16px;
          .flex_content{
            display: flex;
            .name{
              margin-right: 10px;
              // min-width: 80px;
            }
          }
          div{
            margin-bottom: 6px;
          }
        }
      }
    }
    .copyright {
      text-align: center;
      padding: 20px;
      color: rgba(255, 255, 255, 0.5);
      font-size: 16px;
    }
  }
}
</style>